import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import './admin.css';

const AdminLogin = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    
    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) {
            setError('Invalid email or password. Please try again.');
        } else {
            onLogin();
        }
        setLoading(false);
    };

    return (
        <div className="admin-login-page">
            <div className="admin-login-bg" />
            <div className="admin-login-grid" />
            <div className="admin-login-card">
                <div className="admin-login-logo">
                    <div className="admin-login-logo-icon">✈️</div>
                    <h1>Silver Sky Holidays</h1>
                    <p>Administration Portal</p>
                    <div className="admin-login-badge">
                        <i className="fa-solid fa-shield-halved" />
                        Secure Admin Access
                    </div>
                </div>

                {error && (
                    <div className="admin-login-error">
                        <i className="fa-solid fa-circle-exclamation" /> {error}
                    </div>
                )}

                <form onSubmit={handleLogin}>
                    <label className="admin-login-label">Email Address</label>
                    <div className="admin-login-input-wrap">
                        <i className="fa-solid fa-envelope" />
                        <input
                            className="admin-login-input"
                            type="email" required
                            placeholder="admin@silverskyhols.com"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>

                    <label className="admin-login-label">Password</label>
                    <div className="admin-login-input-wrap">
                        <i className="fa-solid fa-lock" />
                        <input
                            className="admin-login-input"
                            type="password" required
                            placeholder="••••••••"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </div>

                    <button className="admin-login-btn" type="submit" disabled={loading}>
                        {loading
                            ? <><i className="fa-solid fa-circle-notch fa-spin" /> Signing in...</>
                            : <><i className="fa-solid fa-right-to-bracket" /> Sign In</>}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
